<template>
  <header class="mainHeader">
    <div class="container">
      <div class="mainHeader__left">
        <router-link class="logo" to="/">
          <img src="@/assets/logoconexa.png" />
        </router-link>
      </div>
      <div class="mainHeader__right">
        <nav class="nav">
          <ul class="nav__list">
            <li
              v-for="({ name, label, path }, index) in navItems"
              :key="index"
              class="nav__item"
            >
              <TabButton :active="isItemActived(name)" :to="path">
                {{ label }}
              </TabButton>
            </li>
          </ul>
        </nav>
        <UserMenu
          :src="currWorkspace.profileImage.url"
          :userName="currFullName"
          :userEmail="currWorkspace.email"
          :open="isUserMenuOpened"
          @logout="logout"
          @toggle="toggleUserMenu"
        >
          <template v-slot:links>
            <router-link
              v-for="({ label, ...item }, index) in userMenuItems"
              :key="index"
              v-bind="item"
              class="textOverflow"
            >
              {{ label }}
            </router-link>
          </template>
        </UserMenu>
      </div>
    </div>
  </header>
</template>

<script>
import TabButton from '@/components/TabButton';
import UserMenu from '@/components/UserMenu';
import { navItems, userMenuItems } from './links';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'Header',
  components: { TabButton, UserMenu },

  data: () => ({
    navItems,
  }),

  computed: {
    ...mapState('app', ['isUserMenuOpened']),
    ...mapState('auth', ['hasMultilogin']),
    ...mapGetters('dashboard', ['currWorkspace', 'currFullName']),
    userMenuItems() {
      const excludes = {
        '/accountSwitch': !this.hasMultilogin,
      };
      return userMenuItems.filter(({ to }) => !excludes[to]);
    },
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('app', ['toggleUserMenu']),
    isItemActived(name) {
      const { $route: currRoute } = this;

      return name === currRoute.name;
    },
  },
};
</script>

<style scoped lang="scss">
@import './style.scss';
</style>
